module.exports = __webpack_public_path__ + "img/treasure-chest.ad00541d.svg";